import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Printer"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 6.75H18.75V2.25H5.25V6.75H3C2.17157 6.75 1.5 7.42157 1.5 8.25V15.75C1.5 16.5784 2.17157 17.25 3 17.25H5.25V21.75H18.75V17.25H21C21.8284 17.25 22.5 16.5784 22.5 15.75V8.25C22.5 7.42157 21.8284 6.75 21 6.75ZM6.75 3.75H17.25V6.75H6.75V3.75ZM17.25 20.25H6.75V12.75H17.25V20.25ZM21 15.75H18.75V11.25H5.25V15.75H3V8.25H21V15.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Printer.vue"]]);
